// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CampaignFormController from "./campaign_form_controller"
application.register("campaign-form", CampaignFormController)

import CampaignChartController from "./campaign_chart_controller"
application.register("campaign-chart", CampaignChartController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import NotesController from "./notes_controller"
application.register("notes", NotesController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import GenerationStatusController from "./generation_status_controller"
application.register("generation-status", GenerationStatusController)

import RateGridController from "./rate_grid_controller"
application.register("rate-grid", RateGridController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)
